import { render, staticRenderFns } from "./configurator.vue?vue&type=template&id=2fd894ec"
import script from "./configurator.vue?vue&type=script&lang=ts"
export * from "./configurator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports